// src/modules/patient/index.js
import React, { Component } from 'react';
import '../../styles/patient.css';
import { API_ENDPOINTS, getRequest, postRequest } from '../../config/apiConfig';

/* ── SVG Icon ───────────────────────────────────────────────── */
const ICONS = {
  home:      'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10',
  calendar:  'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z',
  qr:        'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM20 14v3M17 20h3M20 20v1',
  pill:      'M10.5 20H4a2 2 0 01-2-2V6a2 2 0 012-2h7M20 8V4a2 2 0 00-2-2h-2.5M14 12l-3 3M17 9l-3 3M21 15a6 6 0 11-8.485 8.485',
  flask:     'M9 3h6M9 3v6l-4.5 9A2 2 0 006.5 21h11a2 2 0 001.996-2.1L15 9V3',
  menu:      'M3 12h18M3 6h18M3 18h18',
  bell:      'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0',
  logout:    'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
  heartbeat: 'M22 12h-4l-3 9L9 3l-3 9H2',
  check:     'M20 6L9 17l-5-5',
  chevronR:  'M9 18l6-6-6-6',
  download:  'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3',
  printer:   'M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2M6 14h12v8H6z',
  user:      'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z',
  mail:      'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6',
  phone:     'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 0h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 16.92z',
  credit:    'M1 4h22v16H1zM1 10h22',
  alert:     'M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
  info:      'M12 22a10 10 0 100-20 10 10 0 000 20zM12 8h.01M11 12h1v4h1',
  users:     'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75',
  drop:      'M12 2.69l5.66 5.66a8 8 0 11-11.31 0z',
  eye:       'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 100 6 3 3 0 000-6z',
  share:     'M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13',
  building:  'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z',
};

/* ── Ico ────────────────────────────────────────────────────── */
class Ico extends Component {
  render() {
    const { name, size = 18, color = 'currentColor', className = '' } = this.props;
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={className} style={{ flexShrink: 0 }}>
        <path d={ICONS[name] || ICONS.info} />
      </svg>
    );
  }
}

/* ── Data ───────────────────────────────────────────────────── */
// Doctors now fetched from API — see BookAppointment.componentDidMount
const DEPARTMENTS = ['Cardiology','Orthopaedics','General Medicine','Neurology','Paediatrics','Dermatology'];

/* Map API doctor response → BookAppointment card shape
   API fields: DoctorID, FirstName, MiddleName, LastName,
               Specilization, DepartmentName, OPD_Time, OPD_Fees */
function mapDoctorForBooking(raw, idx) {
  const nameParts = [raw.FirstName, raw.MiddleName, raw.LastName].filter(Boolean);
  const fullName  = nameParts.length > 0 ? `Dr. ${nameParts.join(' ')}` : `Doctor ${idx+1}`;
  const qual      = raw.Specilization || raw.Specialization || '';
  const dept      = raw.DepartmentName || raw.Department || 'General';
  const fees      = raw.OPD_Fees || '500';

  // Parse OPD_Time "09:00-12:00" → 30-min slot array
  const slots = [];


  return {
    id:    String(raw.DoctorID || idx),
    name:  fullName,
    dept,
    qual,
    slots,
    fees,
  };
}

/* ── Btn ────────────────────────────────────────────────────── */
class Btn extends Component {
  render() {
    const { label, icon, variant='primary', size='md', onClick, disabled, full, children } = this.props;
    return (
      <button
        className={`pt-btn pt-btn-${variant} pt-btn-${size}${full?' pt-btn-full':''}`}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
      >
        {icon && <Ico name={icon} size={size==='sm'?13:size==='lg'?18:15} />}
        {label || children}
      </button>
    );
  }
}

/* ── Badge ──────────────────────────────────────────────────── */
function Badge({ label, bg, color }) {
  return <span className="pt-badge" style={{ background:bg, color }}>{label}</span>;
}

/* ── Field ──────────────────────────────────────────────────── */
class Field extends Component {
  render() {
    const { label, required, error, icon, children } = this.props;
    return (
      <div className="pt-field">
        {label && (
          <label className="pt-field-label">
            {label}{required && <span className="pt-required">*</span>}
          </label>
        )}
        <div className="pt-input-wrap">
          {icon && (
            <span className="pt-input-icon" style={{ top:'50%', transform:'translateY(-50%)' }}>
              <Ico name={icon} size={16} />
            </span>
          )}
          {children}
        </div>
        {error && (
          <div className="pt-field-error">
            <Ico name="alert" size={12} color="var(--danger)" /> {error}
          </div>
        )}
      </div>
    );
  }
}

/* ── QR Block — uses canvas API directly (no external lib needed) ── */
class QRBlock extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.state = { qrDataUrl: null };
  }

  componentDidMount()  { this.generateQR(); }
  componentDidUpdate(prev) {
    if (prev.apptId !== this.props.apptId || prev.isPaid !== this.props.isPaid) {
      this.generateQR();
    }
  }

  buildQRData() {
    const { apptId } = this.props;
    // Encode a URL — phone camera will open browser directly to /scan?id=10
    const base = window.location.origin;   // e.g. http://192.168.29.44:3000
    return `${base}/scan?id=${apptId}`;
  }

  async generateQR() {
    const { apptId } = this.props;
    const qrData = this.buildQRData();

    // Load qrcode.js from CDN
    await new Promise(resolve => {
      if (window.QRCode) { resolve(); return; }
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
      s.onload = resolve;
      s.onerror = resolve; // resolve anyway so we don't block
      document.head.appendChild(s);
    });

    if (!window.QRCode || !this.canvasRef.current) return;

    // Clear previous
    this.canvasRef.current.innerHTML = '';

    // Create QR — qrcodejs renders both <canvas> and <img>
    new window.QRCode(this.canvasRef.current, {
      text:         qrData,
      width:        200,
      height:       200,
      colorDark:    '#0D1117',
      colorLight:   '#FFFFFF',
      correctLevel: window.QRCode.CorrectLevel.L,  // L = max capacity ~2953 chars
    });

    // qrcodejs renders both <canvas> and <img> — wait then extract
    setTimeout(() => {
      if (!this.canvasRef.current) return;

      // Try canvas first
      const canvas = this.canvasRef.current.querySelector('canvas');
      if (canvas) {
        const base64 = canvas.toDataURL('image/png');
        this.setState({ qrDataUrl: base64 });
        this.saveQRToDatabase(apptId, qrData, base64);
        if (this.props.onQrReady) this.props.onQrReady(base64);
        return;
      }

      // Fallback: use img src generated by qrcodejs
      const img = this.canvasRef.current.querySelector('img');
      if (img && img.src) {
        this.setState({ qrDataUrl: img.src });
        this.saveQRToDatabase(apptId, qrData, img.src);
      }
    }, 800);
  }

  async saveQRToDatabase(apptId, qrData, base64) {
    if (!apptId || apptId === '—' || String(apptId).startsWith('APT-')) {
      console.log('QR save skipped — no real AppointmentID yet');
      return;
    }
    try {
      const { patient, doctor, date, time, isPaid, dept, gender, blood, reason, fees } = this.props;
      const payload = {
        AppointmentID: String(apptId),
        QR_Data:       qrData,   // short pipe-separated string encoded in QR
        QR_Image:      base64,
        // Full info stored in DB separately
        Patient:       patient  || '',
        Doctor:        doctor   || '',
        Department:    dept     || '',
        Date:          date     || '',
        Time:          time     || '',
        Gender:        gender   || '',
        BloodGroup:    blood    || '',
        Reason:        reason   || '',
        Fees:          fees     || '',
        Status:        isPaid ? 'Paid' : 'Pending',
        QRType:        isPaid ? 'Official QR' : 'Temporary QR',
      };
      console.log('Saving QR to DB for Appt #', apptId);
      const res  = await postRequest(API_ENDPOINTS.QR_GENERATE, payload);
      const data = await res.json();
      console.log('QR saved to DB ✅', data);
    } catch (err) {
      console.warn('QR DB save failed (non-critical):', err.message);
    }
  }

  render() {
    const { apptId, patient, doctor, date, time, isPaid } = this.props;
    const { qrDataUrl } = this.state;
    const accent  = isPaid ? 'var(--accent)' : 'var(--warn)';
    const border  = isPaid ? '#a7f3d0' : '#fcd9c4';
    const bg      = isPaid ? 'var(--accent-light)' : 'var(--warn-light)';

    return (
      <div className={`pt-qr-block ${isPaid?'official':'temporary'}`} style={{ textAlign:'center' }}>

        {/* QR container */}
        <div style={{
          display:'inline-flex', alignItems:'center', justifyContent:'center',
          padding:14, borderRadius:16, background:'#fff',
          boxShadow:'0 4px 20px rgba(0,0,0,.12)',
          marginBottom:14, border:`2.5px solid ${border}`,
          minWidth:228, minHeight:228, position:'relative',
        }}>
          {/* qrcodejs renders here — always in DOM so canvas paints correctly */}
          <div ref={this.canvasRef}
            style={{ position: qrDataUrl ? 'absolute' : 'relative', opacity: qrDataUrl ? 0 : 1, pointerEvents:'none' }} />

          {/* Clean extracted PNG shown once ready */}
          {qrDataUrl && (
            <img src={qrDataUrl} alt="Appointment QR Code"
              style={{ width:200, height:200, display:'block' }} />
          )}

          {/* Loading spinner */}
          {!qrDataUrl && (
            <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:8, color:'var(--text-3)', fontSize:12 }}>
              <div style={{ width:32, height:32, border:'3px solid var(--border)', borderTop:'3px solid var(--brand)', borderRadius:'50%', animation:'ptSpin 1s linear infinite' }} />
              Generating QR…
            </div>
          )}
        </div>

        {/* Status label */}
        <div style={{ fontSize:11, fontWeight:800, letterSpacing:1.4, color:accent, marginBottom:10, textTransform:'uppercase' }}>
          {isPaid ? '✓ Official QR Code' : '⏳ Temporary QR Code'}
        </div>

        {/* Info summary */}
        <div style={{ background:bg, borderRadius:12, padding:'12px 16px', textAlign:'left', fontSize:12, color:'var(--text-2)', lineHeight:2.1 }}>
          <div><strong>Appt ID:</strong> #{apptId}</div>
          <div><strong>Patient:</strong> {patient}</div>
          <div><strong>Doctor:</strong>  {doctor}</div>
          <div><strong>Date:</strong>    {date} · {time}</div>
        </div>

        {/* Badge */}
        <div style={{ marginTop:12, padding:'6px 18px', borderRadius:20, display:'inline-block', background:accent, color:'#fff', fontSize:11, fontWeight:700 }}>
          {isPaid ? 'Payment Confirmed' : 'Pending — Pay at Counter'}
        </div>
      </div>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   SIDEBAR
═══════════════════════════════════════════════════════════════ */
class Sidebar extends Component {
  render() {
    const { activePage, onNav, isOpen, onClose, onLogout } = this.props;

    // ── Read user from localStorage ──────────────────────────────
    let userName = 'Guest Patient';
    let initials = 'GP';
    try {
      const raw = localStorage.getItem('dg_user');
      if (raw) {
        const u = JSON.parse(raw);
        if (u.name) {
          userName = u.name;
          initials = u.name
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map(w => w[0].toUpperCase())
            .join('');
        }
      }
    } catch (e) {
      // localStorage not available or invalid JSON — use defaults
    }

    const NAV = [
      { id:'book',         label:'Book Appointment', icon:'calendar' },
      { id:'my-qr',        label:'My QR Code',       icon:'qr'       },
      { id:'prescription', label:'Prescription',      icon:'pill'     },
      { id:'lab-results',  label:'Lab Results',       icon:'flask'    },
    ];
    return (
      <>
        <div className={`pt-overlay${isOpen?' show':''}`} onClick={onClose} />
        <aside className={`pt-sidebar${isOpen?' open':''}`}>
          {/* Logo */}
          <div className="pt-sidebar-logo">
            <div className="pt-sidebar-logo-icon">
              <Ico name="heartbeat" size={18} color="#fff" />
            </div>
            <div>
              <div className="pt-sidebar-logo-name">DG Doctor</div>
              <div className="pt-sidebar-logo-sub">Hospital System</div>
            </div>
          </div>
          {/* User */}
          <div className="pt-sidebar-user">
            <div className="pt-sidebar-avatar">{initials}</div>
            <div>
              <div className="pt-sidebar-uname">{userName}</div>
              <div className="pt-sidebar-urole">Patient</div>
            </div>
          </div>
          {/* Nav */}
          <nav className="pt-sidebar-nav">
            <div className="pt-nav-section">Menu</div>
            {NAV.map(item => (
              <button key={item.id}
                className={`pt-nav-btn${activePage===item.id?' active':''}`}
                onClick={() => { onNav(item.id); onClose(); }}>
                <Ico name={item.icon} size={16}
                  color={activePage===item.id?'var(--brand)':'var(--text-3)'} />
                {item.label}
                {activePage===item.id && <div className="pt-nav-dot" />}
              </button>
            ))}
          </nav>
          <button className="pt-sidebar-signout" onClick={onLogout}>
            <Ico name="logout" size={15} /> Sign out
          </button>
        </aside>
      </>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   HEADER
═══════════════════════════════════════════════════════════════ */
class Header extends Component {
  render() {
    const { title, subtitle, onMenuClick } = this.props;
    return (
      <header className="pt-header">
        <button className="pt-header-menu" onClick={onMenuClick}>
          <Ico name="menu" size={20} />
        </button>
        <div>
          <div className="pt-header-title">{title}</div>
          {subtitle && <div className="pt-header-sub">{subtitle}</div>}
        </div>
        <div className="pt-header-actions">
          <div className="pt-header-bell">
            <Ico name="bell" size={17} color="var(--text-2)" />
            <div className="pt-header-bell-dot" />
          </div>
          <div className="pt-header-avatar">RS</div>
        </div>
      </header>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   BOOK APPOINTMENT — 4-step wizard
═══════════════════════════════════════════════════════════════ */
class BookAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      form: {
        // Who is this for?
        selfRelative: 'self',   // 'self' | 'relative'
        // Patient info
        firstName:'', lastName:'', dob:'', age:'',
        bloodGroup:'', gender:'', mobile:'', phone:'', email:'',
        reason:'',
        // Step 2
        dept:'', doctor:null, date:'', time:'',
      },
      payMethod: '',
      payLater: false,
      apptId: 'APT-' + Math.floor(2400 + Math.random() * 99),
      errors: {},
      // ── Doctor list from API ─────────────────────────────────
      doctors:        [],
      doctorsLoading: true,
      slotsLoading:  false,
      apiSlots:      [],   // time slots from API for selected doctor
      doctorsError:   null,
      // ── Booking API ──────────────────────────────────────────
      bookingLoading: false,
      bookingError:   null,
      bookingApptId:  null,   // real ID returned from API
      confirmedQrUrl: null,   // base64 QR image for download/print/share
    };
  }

  componentDidMount() {
    this.fetchDoctors();
    this.prefillSelf();   // auto-fill if logged-in user selects "Myself"
  }

  /* Read dg_user from localStorage and return mapped fields.
     Returns null for guest users (isGuest:true) or if no session. */
  getUserFromStorage() {
    try {
      const raw = localStorage.getItem('dg_user');
      if (!raw) return null;
      const u = JSON.parse(raw);
      if (u.isGuest) return null;   // guest → blank fields
      return u;                      // real user → prefill
    } catch (e) {
      return null;
    }
  }

  /* Split "Anshul Agarwal" → { firstName:'Anshul', lastName:'Agarwal' } */
  splitName(fullName) {
    if (!fullName) return { firstName:'', lastName:'' };
    const parts = fullName.trim().split(' ').filter(Boolean);
    const firstName = parts[0] || '';
    const lastName  = parts.slice(1).join(' ') || '';
    return { firstName, lastName };
  }

  /* Prefill Step 1 fields from localStorage when "Myself" is selected.
     dg_user now stores flat fields: firstName, lastName, dob, gender,
     bloodGroup, mobile, email — set at login time. */
  prefillSelf() {
    const u = this.getUserFromStorage();
    if (!u) return;   // guest or no session → leave blank

    // firstName/lastName stored directly; fallback: split u.name
    const firstName = u.firstName || this.splitName(u.name).firstName;
    const lastName  = u.lastName  || this.splitName(u.name).lastName;

    // DOB: stored as ISO "1992-05-03T18:30:00.000Z" → convert to "YYYY-MM-DD" for date input
    const rawDob = u.dob || '';
    const dob    = rawDob ? rawDob.split('T')[0] : '';
    const age    = dob ? this.calcAge(dob) : '';

    this.setState(s => ({
      form: {
        ...s.form,
        firstName,
        lastName,
        dob,
        age,
        bloodGroup: u.bloodGroup || '',
        gender:     u.gender     || '',
        mobile:     u.mobile     || u.phone || '',
        phone:      u.phone      || '',
        email:      u.email      || '',
      }
    }));
  }

  /* Clear all patient fields back to blank (for Relative or guest) */
  clearPatientFields() {
    this.setState(s => ({
      form: {
        ...s.form,
        firstName:'', lastName:'', dob:'', age:'',
        bloodGroup:'', gender:'', mobile:'', phone:'', email:'',
      },
      errors: {},
    }));
  }

  async fetchDoctors() {
    this.setState({ doctorsLoading: true, doctorsError: null });
    try {
      const res  = await getRequest(API_ENDPOINTS.DOCTOR_LIST);
      const data = await res.json();
      console.log('Doctor list API raw:', data);

      // Handle all known response shapes:
      // { status, data: [[...rows], meta] }  ← SP double-array shape
      // { status, data: { Doctor: [...] } }  ← named key
      // { data: [...] }                      ← flat array in data
      // [...]                                ← direct array
      let rows = [];
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) {
        rows = data.data[0];                       // ✅ SP shape
      } else if (Array.isArray(data.data?.Doctor)) {
        rows = data.data.Doctor;
      } else if (Array.isArray(data.data)) {
        rows = data.data;
      } else if (Array.isArray(data)) {
        rows = data;
      }

      const doctors = rows.map(mapDoctorForBooking);
      this.setState({ doctors, doctorsLoading: false }, () => {
        console.log('BookAppointment doctors mapped =', this.state.doctors);
      });
    } catch (err) {
      console.error('BookAppointment fetchDoctors error:', err);
      // Fallback demo doctors so UI never breaks
      this.setState({
        doctors: [
          
        ],
        doctorsLoading: false,
        doctorsError: err.message,
      });
    }
  }

  setForm(key, val) {
    this.setState(s => ({ form:{...s.form,[key]:val}, errors:{...s.errors,[key]:''} }));
  }

  validateStep1() {
    const { firstName, lastName, dob, gender, mobile, reason, doctor, date, time } = this.state.form;
    const e = {};
    if (!firstName.trim()) e.firstName = 'First name is required.';
    if (!lastName.trim())  e.lastName  = 'Last name is required.';
    if (!dob)              e.dob       = 'Date of birth is required.';
    if (!gender)           e.gender    = 'Please select gender.';
    if (!mobile.trim())    e.mobile    = 'Mobile number is required.';
    else if (!/^\d{10}$/.test(mobile.replace(/\s/g,''))) e.mobile = 'Enter valid 10-digit number.';
    if (!doctor)           e.doctor    = 'Please select a doctor.';
    if (!date)             e.date      = 'Please select a date.';
    if (!time)             e.time      = 'Please select a time slot.';
    return e;
  }

  // Calculate age from DOB string "YYYY-MM-DD"
  calcAge(dob) {
    if (!dob) return '';
    const diff = Date.now() - new Date(dob).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  }

  validateStep2() {
    const { doctor, date, time } = this.state.form;
    const e = {};
    if (!doctor) e.doctor = 'Please select a doctor.';
    if (!date)   e.date   = 'Please select a date.';
    if (!time)   e.time   = 'Please select a time slot.';
    return e;
  }

  async fetchTimeSlotsForDoctor(doctorId, date) {
    if (!doctorId) return;
    this.setState({ slotsLoading: true, apiSlots: [] });
    try {
      const payload = { DoctorID: doctorId };
      if (date) payload.AppointmentDate = date;
      const res  = await postRequest(API_ENDPOINTS.TIME_SLOT_LIST_ForPatient, payload);
      const data = await res.json();
      console.log('Time slots for doctor', doctorId, ':', data);
      let rows = [];
      if (data.status && Array.isArray(data.data?.Doctor)) rows = data.data.Doctor;
      else if (data.status && Array.isArray(data.data))    rows = data.data;
      else if (Array.isArray(data))                        rows = data;
      this.setState({ slotsLoading: false, apiSlots: rows });
    } catch(err) {
      console.warn('fetchTimeSlotsForDoctor error:', err.message);
      this.setState({ slotsLoading: false });
    }
  }

  next() {
    const { step } = this.state;
    const errs = step===1 ? this.validateStep1() : {};
    if (Object.keys(errs).length > 0) { this.setState({ errors:errs }); return; }
    this.setState({ step: step+1, errors:{} });
  }

  back() { this.setState(s => ({ step:s.step-1, errors:{} })); }

  /* Called when user clicks "Pay Later" or "Pay Now".
     payLater=true  → QR_Type = "Temprory QR"
     payLater=false → QR_Type = "Official QR"   */
  async pay(later) {
    const { form, apptId } = this.state;
    const qrType = later ? 'Temprory QR' : 'Official QR';

    // Read PersonID from localStorage — null for guest users
    const storedUser = this.getUserFromStorage();
    const personId   = storedUser?.personId ?? null;

    // SP expects VARCHAR — always convert IDs to string, null stays null
    const toStr = v => (v !== null && v !== undefined) ? String(v) : null;

    // Convert date input "YYYY-MM-DD" → clean date string for backend
    // Backend/SP should handle quoting — we just send the plain date
    const toMySQLDate = d => {
      if (!d) return null;
      return d.split('T')[0];   // "2026-04-02"  (no time suffix)
    };

    // Build payload matching SP parameters exactly:
    // p_personId, p_doctorId, p_Date, p_Time, p_Reason,
    // p_AppointmentType, p_QRType, p_OPDFees, p_Status
    const payload = {
      // SP param: p_personId → VARCHAR — send as string or null for guest
      PersonID:        toStr(personId),

      // SP param: p_doctorId → VARCHAR
      DoctorID:        toStr(form.doctor?.id),

      // SP param: p_Date → DATETIME — "YYYY-MM-DD 00:00:00"
      AppointmentDate: toMySQLDate(form.date),

      // SP param: p_Time → VARCHAR — e.g. "9:00 AM"
      AppointmentTime: form.time || '',

      // SP param: p_Reason → VARCHAR
      ReasonForVisit:  form.reason || '',

      // SP param: p_AppointmentType → VARCHAR — "self" | "relative"
      SelfRelative:    form.selfRelative || 'self',

      // SP param: p_QRType → VARCHAR — "Temprory QR" | "Official QR"
      QR_Type:         qrType,

      // SP param: p_OPDFees → VARCHAR — e.g. "500.00"
      OPD_Fees:        String(form.doctor?.fees || '500'),

      // SP param: p_Status → VARCHAR — "Paid" | "Pending"
      PaymentStatus:   later ? 'Pending' : 'Paid',
      Channel:         "Online",

      // Extra patient fields (used by backend outside SP if needed)
      FirstName:        form.firstName   || '',
      Lastname:        form.lastName    || '',
      DOB:          form.dob         || '',
      BloodGroup:           form.bloodGroup  || '',
      Gender:       form.gender      || '',
      Mobile:       form.mobile      || '',
      patPhone:        form.phone       || '',
      email:        form.email       || '',
      DepartmentName:  form.doctor?.dept || '',
    };

    console.log('Book Appointment payload:', payload);

    this.setState({ bookingLoading: true, bookingError: null, payLater: later });

    try {
      const res  = await postRequest(API_ENDPOINTS.BOOK_APPOINTMENT, payload);
      const data = await res.json();
      console.log('Book Appointment response:', data);

      // Check for server-side error
      if (!res.ok || data?.status === false || data?.success === false) {
        const errMsg = data?.message || data?.error || `Server error (${res.status})`;
        this.setState({ bookingLoading: false, bookingError: errMsg });
        return;  // Stay on step 2/3 — DO NOT generate QR
      }

      // Accept various response shapes
      const serverApptId= data?.data?.data.appointmentId || null;;

      if (!serverApptId) {
        // Response OK but no ID — show error
        this.setState({ bookingLoading: false, bookingError: 'Booking failed: No appointment ID returned. Please try again.' });
        return;
      }

      this.setState({
        bookingLoading: false,
        bookingApptId:  String(serverApptId),
        bookingError:   null,
        step: 4,
      });

      // Auto-login guest after successful booking
      if (personId === null) {
        this.autoLoginGuest(String(serverApptId));
      }

    } catch (err) {
      console.error('Book Appointment error:', err);
      this.setState({
        bookingLoading: false,
        bookingError:   'Could not connect to server. Please check your connection and try again.',
      });
      // Stay on current step — DO NOT show QR
    }
  }

  /* After a guest books successfully, auto-create a session from
     the form data and call props.onLogin → App.handleLogin →
     saves to localStorage + navigates to /patientDashboard.
     Small delay so the user sees the Step 4 confirmation briefly. */
  autoLoginGuest(apptId) {
    const { form } = this.state;
    const fullName = `${form.firstName || ''} ${form.lastName || ''}`.trim() || 'Patient';

    const guestUser = {
      personId:   null,             // still no account — guest booking
      name:       fullName,
      firstName:  form.firstName  || '',
      lastName:   form.lastName   || '',
      email:      form.email      || '',
      mobile:     form.mobile     || '',
      dob:        form.dob        || '',
      gender:     form.gender     || '',
      bloodGroup: form.bloodGroup || '',
      role:       'patient',
      isGuest:    true,             // marks as guest so prefill knows
      bookingApptId: apptId,        // carry the new appointment ID
    };

    // Save to localStorage so My QR page can read it
    localStorage.setItem('dg_user', JSON.stringify(guestUser));

    // Wait 2 seconds so user sees the confirmation QR, then redirect
    setTimeout(() => {
      if (this.props.onLogin) {
        this.props.onLogin(guestUser);   // → App.handleLogin → /patientDashboard
      }
    }, 2000);
  }

  reset() {
    this.setState({ step:1, form:{ selfRelative:'self', firstName:'', lastName:'', dob:'', age:'', bloodGroup:'', gender:'', mobile:'', phone:'', email:'', reason:'', dept:'', doctor:null, date:'', time:'' }, payMethod:'', errors:{}, apptId:'APT-'+Math.floor(2400+Math.random()*99) });
  }

  renderStepper() {
    const { step } = this.state;
    const STEPS = [
      {n:1,label:'Patient Details'},{n:2,label:'Payment'},{n:3,label:'Confirmation'}
    ];
    return (
      <div className="pt-stepper">
        {STEPS.map((s,i) => (
          <React.Fragment key={s.n}>
            <div className="pt-step-item">
              <div className={`pt-step-circle ${step>s.n?'done':step===s.n?'active':'pending'}`}>
                {step>s.n ? <Ico name="check" size={15} color="#fff" /> : s.n}
              </div>
              <div className={`pt-step-label ${step===s.n?'active':'pending'}`}>{s.label}</div>
            </div>
            {i<STEPS.length-1 && <div className={`pt-step-line ${step>s.n?'done':'pending'}`} />}
          </React.Fragment>
        ))}
      </div>
    );
  }

  renderStep1() {
    const { form, errors } = this.state;
    const BLOOD_GROUPS = ['A+','A-','B+','B-','AB+','AB-','O+','O-'];
    // Show TimeSlot as-is, hide if fully booked or time passed
    const todayStr = new Date().toISOString().split('T')[0];
    const isToday  = form.date === todayStr;
    const now      = new Date();

    const slotPassed = slotStr => {
      // Only hide passed slots when today is selected AND a date is chosen
      if (!form.date || !isToday || !slotStr) return false;
      // Use END time — slot "10:00 AM-01:00 PM" is visible until 12:59 PM
      const parts = slotStr.split(/\s*-\s*/);
      const endPart = parts[parts.length - 1].trim();
      const m = endPart.match(/^(\d+):(\d+)\s*(AM|PM)$/i);
      if (!m) return false;
      let h = parseInt(m[1]), min = parseInt(m[2]);
      const p = m[3].toUpperCase();
      if (p === 'PM' && h !== 12) h += 12;
      if (p === 'AM' && h === 12) h = 0;
      // Subtract 1 minute — slot visible until end time - 1 min
      const endTime = new Date();
      endTime.setHours(h, min - 1, 59, 0);
      return now > endTime;
    };

    const apiSlots = (this.state.apiSlots || [])
      .filter(s => (s.Status || 'Active').toLowerCase() === 'active')
      .filter(s => (s.booked_count || 0) < (s.No_of_Patient || 1))
      .map(s => (s.TimeSlot || '').trim())
      .filter(Boolean)
      .filter(s => !slotPassed(s));

    const timeSlots = apiSlots
      

    return (
      <div className="pt-card pt-fade-up">
        <div className="pt-card-body">

          {/* ══ SECTION 1: Appointment Details ══ */}
          <div className="pt-section-title" style={{display:'flex',alignItems:'center',gap:8,marginBottom:16}}>
            <Ico name="calendar" size={14} color="var(--brand)" /> Appointment Details
          </div>

          {/* Doctor dropdown */}
          <Field label="Select Doctor" required error={errors.doctor} icon="user">
            {this.state.doctorsLoading ? (
              <div className="pt-input" style={{display:'flex',alignItems:'center',gap:8,color:'var(--text-3)',pointerEvents:'none',background:'var(--bg)'}}>
                <Ico name="calendar" size={14} /> Loading doctors…
              </div>
            ) : (
              <select className={`pt-select${errors.doctor?' error':''}`}
                value={form.doctor?.id || ''}
                onChange={e => {
                  const doc = this.state.doctors.find(d => String(d.id) === e.target.value) || null;
                  this.setForm('doctor', doc);
                  this.setForm('time', '');
                  
                }}>
                <option value="">— Select a doctor —</option>
                {this.state.doctors.map(doc => (
                  <option key={doc.id} value={doc.id}>
                    {doc.name} · {doc.dept}{doc.fees ? ` · ₹${doc.fees}` : ''}
                  </option>
                ))}
              </select>
            )}
          </Field>

          {/* Selected doctor info card */}
          {form.doctor && (
            <div style={{
              background:'var(--brand-light)', borderRadius:10, padding:'12px 16px',
              marginTop:-4, marginBottom:14,
              display:'flex', alignItems:'center', gap:12,
              border:'1px solid var(--brand-mid)',
            }}>
              <div style={{
                width:38, height:38, borderRadius:9, background:'var(--brand)',
                display:'flex', alignItems:'center', justifyContent:'center',
                color:'#fff', fontSize:13, fontWeight:700, flexShrink:0,
              }}>
                {form.doctor.name.replace(/^Dr\.\s*/i,'').split(' ').map(p=>p[0]).slice(0,2).join('')}
              </div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700, fontSize:14, color:'var(--brand)'}}>{form.doctor.name}</div>
                <div style={{fontSize:11, color:'var(--text-2)', marginTop:1}}>
                  {form.doctor.qual}{form.doctor.dept ? ` · ${form.doctor.dept}` : ''}
                </div>
              </div>
              {form.doctor.fees && (
                <span style={{
                  fontSize:13, fontWeight:700, padding:'4px 12px', borderRadius:20,
                  background:'#FFF4EC', color:'var(--warn)', border:'1px solid #fcd9c4',
                }}>₹{form.doctor.fees}</span>
              )}
            </div>
          )}

          {/* Date + Time */}
          {(() => {
            const parseSlot = slot => {
              const m = slot.match(/^(\d+):(\d+)\s*(AM|PM)$/i);
              if (!m) return null;
              let h = parseInt(m[1]), min = parseInt(m[2]);
              const p = m[3].toUpperCase();
              if (p === 'PM' && h !== 12) h += 12;
              if (p === 'AM' && h === 12) h = 0;
              const t = new Date(); t.setHours(h, min, 0, 0);
              return t;
            };
            const availableSlots = isToday
              ? timeSlots.filter(s => { const t = parseSlot(s); return t ? t > now : true; })
              : timeSlots;
            const hiddenCount = timeSlots.length - availableSlots.length;
            return (
              <div className="pt-row-2">
                <Field label="Appointment Date" required error={errors.date} icon="calendar">
                  <input type="date" className={`pt-input${errors.date?' error':''}`}
                    value={form.date}
                    min={new Date().toISOString().split('T')[0]}
                    onChange={e => {
                      this.setForm('date', e.target.value);
                      this.setForm('time', '');
                      if (form.doctor?.id) this.fetchTimeSlotsForDoctor(form.doctor.id, e.target.value);
                    }} />
                </Field>
                <Field label="Time Slot" required error={errors.time} icon="calendar">
                  <select className={`pt-select${errors.time?' error':''}`}
                    value={form.time}
                    onChange={e => this.setForm('time', e.target.value)}
                    disabled={!form.doctor || !form.date || this.state.slotsLoading}>
                    <option value="">
                      {!form.doctor ? 'Select doctor first'
                        : this.state.slotsLoading ? 'Loading slots…'
                        : !form.date ? 'Select date first'
                        : availableSlots.length === 0 ? 'No slots available'
                        : 'Select time slot'}
                    </option>
                    {availableSlots.map(t => <option key={t}>{t}</option>)}
                  </select>
                  {isToday && availableSlots.length === 0 && (
                    <div style={{fontSize:11,color:'var(--warn)',marginTop:4}}>
                      No slots available for this date.
                    </div>
                  )}
                  
                </Field>
              </div>
            );
          })()}

          {/* ══ DIVIDER ══ */}
          <div style={{borderTop:'1px solid var(--border)', margin:'20px 0'}} />

          {/* ══ SECTION 2: Appointment For ══ */}
          <div className="pt-section-title" style={{display:'flex',alignItems:'center',gap:8,marginBottom:14}}>
            <Ico name="user" size={14} color="var(--brand)" /> Appointment For
          </div>
          <div className="pt-self-rel-row">
            {[
              { key:'self',     label:'Myself',           icon:'user'  },
              { key:'relative', label:'Relative / Other', icon:'users' },
            ].map(opt => (
              <button key={opt.key} type="button"
                className={`pt-self-rel-btn${form.selfRelative===opt.key?' active':''}`}
                onClick={() => {
                  this.setForm('selfRelative', opt.key);
                  if (opt.key === 'self') this.prefillSelf();
                  else this.clearPatientFields();
                }}>
                <Ico name={opt.icon} size={15}
                  color={form.selfRelative===opt.key?'var(--brand)':'var(--text-3)'} />
                {opt.label}
              </button>
            ))}
          </div>

          {/* Hints */}
          {form.selfRelative === 'self' && !this.getUserFromStorage() && (
            <div style={{display:'flex',alignItems:'center',gap:6,fontSize:12,color:'var(--text-3)',marginTop:8,padding:'8px 12px',background:'var(--bg)',borderRadius:9}}>
              <Ico name="info" size={13} color="var(--text-3)" />
              Logged in as guest — please fill in your details below.
            </div>
          )}
          {form.selfRelative === 'self' && this.getUserFromStorage() && (
            <div style={{display:'flex',alignItems:'center',gap:6,fontSize:12,color:'#059669',marginTop:8,padding:'8px 12px',background:'var(--accent-light)',borderRadius:9,border:'1px solid #a7f3d0'}}>
              <Ico name="check" size={13} color="#059669" />
              Details filled from your profile. You can edit if needed.
            </div>
          )}

          {/* ══ SECTION 3: Patient Information ══ */}
          <div className="pt-section-title" style={{display:'flex',alignItems:'center',gap:8,margin:'20px 0 14px'}}>
            <Ico name="user" size={14} color="var(--brand)" /> Patient Information
          </div>

          {/* Row 1 — First Name + Last Name */}
          <div className="pt-row-2">
            <Field label="First Name" required error={errors.firstName} icon="user">
              <input className={`pt-input${errors.firstName?' error':''}`} placeholder="e.g. Raj"
                value={form.firstName} onChange={e=>this.setForm('firstName',e.target.value)} />
            </Field>
            <Field label="Last Name" required error={errors.lastName} icon="user">
              <input className={`pt-input${errors.lastName?' error':''}`} placeholder="e.g. Sharma"
                value={form.lastName} onChange={e=>this.setForm('lastName',e.target.value)} />
            </Field>
          </div>

          {/* Row 2 — DOB + Age */}
          <div className="pt-row-2">
            <Field label="Date of Birth" required error={errors.dob} icon="calendar">
              <input type="date" className={`pt-input${errors.dob?' error':''}`}
                value={form.dob}
                onChange={e => {
                  const dob = e.target.value;
                  const age = this.calcAge(dob);
                  this.setState(s => ({ form:{...s.form, dob, age}, errors:{...s.errors, dob:''} }));
                }} />
            </Field>
            <Field label="Age (auto-calculated)">
              <input className="pt-input" placeholder="Calculated from DOB"
                value={form.age ? `${form.age} years` : ''}
                readOnly
                style={{background:'var(--bg)',color:'var(--text-2)',cursor:'default'}} />
            </Field>
          </div>

          {/* Row 3 — Gender + Blood Group */}
          <div className="pt-row-2">
            <Field label="Gender" required error={errors.gender}>
              <select className={`pt-select${errors.gender?' error':''}`}
                value={form.gender} onChange={e=>this.setForm('gender',e.target.value)}>
                <option value="">Select gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </Field>
            <Field label="Blood Group" icon="drop">
              <select className="pt-select" value={form.bloodGroup}
                onChange={e=>this.setForm('bloodGroup',e.target.value)}>
                <option value="">Select blood group</option>
                {BLOOD_GROUPS.map(b=><option key={b}>{b}</option>)}
              </select>
            </Field>
          </div>

          {/* Row 4 — Mobile + Phone */}
          <div className="pt-row-2">
            <Field label="Mobile Number" required error={errors.mobile} icon="phone">
              <input type="tel" className={`pt-input${errors.mobile?' error':''}`}
                placeholder="10-digit mobile" maxLength={10}
                value={form.mobile} onChange={e=>this.setForm('mobile',e.target.value)} />
            </Field>
            <Field label="Phone (Optional)" icon="phone">
              <input type="tel" className="pt-input" placeholder="Alternate number"
                value={form.phone} onChange={e=>this.setForm('phone',e.target.value)} />
            </Field>
          </div>

          {/* Row 5 — Email */}
          <Field label="Email Address" icon="mail">
            <input type="email" className="pt-input" placeholder="your@email.com"
              value={form.email} onChange={e=>this.setForm('email',e.target.value)} />
          </Field>

          {/* Reason */}
          <Field label="Reason for Visit" error={errors.reason}>
            <textarea className={`pt-textarea${errors.reason?' error':''}`} rows={3}
              placeholder="Describe your symptoms briefly…" style={{paddingLeft:14}}
              value={form.reason} onChange={e=>this.setForm('reason',e.target.value)} />
          </Field>

          <div style={{textAlign:'right',marginTop:16}}>
            <Btn label="Next: Payment" icon="chevronR" variant="primary" onClick={()=>this.next()} />
          </div>
        </div>
      </div>
    );
  }



  renderStep3() {
    const { form, payMethod } = this.state;
    return (
      <div className="pt-card pt-fade-up">
        <div className="pt-card-body">
          <div style={{background:'var(--bg)',borderRadius:12,padding:18,marginBottom:20,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <div style={{fontSize:12,color:'var(--text-3)',marginBottom:4}}>Consultation Fee</div>
              <div style={{fontSize:32,fontWeight:800,fontFamily:'var(--font-display)'}}>₹ {form.doctor?.fees || '500'}</div>
              <div style={{fontSize:12,color:'var(--text-2)',marginTop:3}}>{form.doctor?.name} · {form.doctor?.dept}</div>
            </div>
            <Ico name="credit" size={44} color="var(--border)" />
          </div>
          <div className="pt-section-title">Select Payment Method</div>
          <div className="pt-pay-methods">
            {[{k:'upi',l:'📱 UPI'},{k:'card',l:'💳 Debit / Credit'},{k:'net',l:'🏦 Net Banking'}].map(m=>(
              <div key={m.k} className={`pt-pay-method${payMethod===m.k?' selected':''}`}
                onClick={()=>this.setState({payMethod:m.k})}>{m.l}</div>
            ))}
          </div>
          {/* Booking error */}
          {this.state.bookingError && (
            <div style={{background:'#FFF0EB',border:'1.5px solid #fcd9c4',borderRadius:12,padding:'14px 16px',marginBottom:14,marginTop:4,display:'flex',gap:10,alignItems:'flex-start'}}>
              <Ico name="alert" size={16} color="#FF6B35" />
              <div>
                <div style={{fontWeight:700,fontSize:14,color:'#c0392b',marginBottom:4}}>Booking Failed</div>
                <div style={{fontSize:13,color:'#c0392b'}}>{this.state.bookingError}</div>
                <div style={{fontSize:12,color:'#888',marginTop:6}}>Please try again or contact support.</div>
              </div>
            </div>
          )}
          <div style={{display:'flex',gap:10,justifyContent:'space-between',flexWrap:'wrap'}}>
            <Btn label="← Back" variant="secondary" onClick={()=>this.back()} disabled={this.state.bookingLoading} />
            <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
              <Btn
                label={this.state.bookingLoading && this.state.payLater ? 'Booking…' : 'Pay Later (Temp QR)'}
                variant="secondary"
                disabled={this.state.bookingLoading}
                onClick={()=>this.pay(true)} />
              <Btn
                label={this.state.bookingLoading && !this.state.payLater ? 'Processing…' : `Pay ₹${form.doctor?.fees || '500'} Now`}
                icon={this.state.bookingLoading && !this.state.payLater ? null : 'credit'}
                variant="primary"
                disabled={!payMethod || this.state.bookingLoading}
                onClick={()=>this.pay(false)} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderStep4() {
    const { form, payLater, apptId, bookingApptId } = this.state;
    const isPaid    = !payLater;
    const displayId = bookingApptId || apptId;   // prefer server ID
    return (
      <div className="pt-card pt-fade-up">
        <div className="pt-card-body">
          <div className="pt-confirm-screen">
            <div style={{display:'flex',gap:10,justifyContent:'center',flexWrap:'wrap'}}>
              {/* Download */}
              <Btn label="Download QR" icon="download" variant="secondary" size="sm" onClick={()=>{
                const url = this.state.confirmedQrUrl;
                if (!url) { alert('QR not ready yet, please wait a moment.'); return; }
                const a = document.createElement('a');
                a.href = url; a.download = `QR-Appt-${displayId}.png`; a.click();
              }} />
              {/* Print */}
              <Btn label="Print" icon="printer" variant="secondary" size="sm" onClick={()=>{
                const url = this.state.confirmedQrUrl;
                if (!url) { alert('QR not ready yet, please wait a moment.'); return; }
                const w = window.open('', '_blank');
                w.document.write(`<html><body style="text-align:center;font-family:sans-serif;padding:30px">
                  <h2>Appointment QR — #${displayId}</h2>
                  <p>${form.firstName||''} ${form.lastName||''} · ${form.date||''} · ${form.time||''}</p>
                  <img src="${url}" style="width:220px;height:220px" />
                  <p style="font-size:12px;color:#666">Dr. ${form.doctor?.name||''} · ${form.doctor?.dept||''}</p>
                  <script>window.onload=()=>{window.print();window.close();}<\/script>
                </body></html>`);
                w.document.close();
              }} />
              {/* Share */}
              <Btn label="Share" icon="share" variant="secondary" size="sm" onClick={async ()=>{
                const url = this.state.confirmedQrUrl;
                const scanUrl = `${window.location.origin}/scan?id=${displayId}`;
                if (navigator.share && url) {
                  try {
                    const blob = await (await fetch(url)).blob();
                    const file = new File([blob], `QR-${displayId}.png`, {type:'image/png'});
                    await navigator.share({title:'My Appointment QR',text:`Appointment #${displayId}`,files:[file],url:scanUrl});
                    return;
                  } catch(_) {}
                }
                // Fallback: copy link
                navigator.clipboard?.writeText(scanUrl).then(()=>alert('Scan link copied to clipboard!')).catch(()=>alert(scanUrl));
              }} />
              {!this.getUserFromStorage()?.personId && (
                <Btn label="Book Another" variant="primary" size="sm" onClick={()=>this.reset()} />
              )}
            </div>

           
            <div className="pt-confirm-icon" style={{background:isPaid?'var(--accent-light)':'var(--warn-light)',marginTop:'25px'}}>
              <Ico name={isPaid?'check':'bell'} size={32} color={isPaid?'var(--accent)':'var(--warn)'} />
            </div>
            <div className="pt-confirm-title">{isPaid?'Booking Confirmed!':'Booking Received!'}</div>
            <p className="pt-confirm-sub">
              {isPaid
                ? 'Payment successful. Official QR Code sent to your email and doctor.'
                : 'Temporary QR sent to your mobile. Pay at hospital counter to get Official QR.'}
            </p>
            <div style={{maxWidth:260,margin:'0 auto 24px'}}>
              <QRBlock
                apptId={displayId}
                patient={`${form.firstName||''} ${form.lastName||''}`.trim() || 'Patient'}
                doctor={form.doctor?.name||'Doctor'}
                dept={form.doctor?.dept||''}
                date={form.date||''}
                time={form.time||''}
                gender={form.gender||''}
                blood={form.bloodGroup||''}
                reason={form.reason||''}
                fees={form.doctor?.fees ? `₹${form.doctor.fees}` : ''}
                isPaid={isPaid}
                onQrReady={url => this.setState({ confirmedQrUrl: url })} />
            </div>

             {/* Guest credentials + redirect notice */}
            {!this.getUserFromStorage()?.personId && (
              <div style={{marginTop:20}}>

                {/* Credentials card */}
                <div style={{
                  borderRadius:14, overflow:'hidden',
                  border:'1px solid #a7f3d0',
                  marginBottom:12,
                }}>
                  {/* Header */}
                  <div style={{
                    background:'var(--accent)', padding:'12px 16px',
                    display:'flex', alignItems:'center', gap:8,
                  }}>
                    <Ico name="check" size={15} color="#fff" />
                    <span style={{fontSize:13,fontWeight:700,color:'#fff'}}>
                      Save your login credentials
                    </span>
                  </div>

                  {/* Body */}
                  <div style={{background:'var(--accent-light)',padding:'16px'}}>
                    <p style={{fontSize:12,color:'#065f46',marginBottom:14,lineHeight:1.6}}>
                      Your account has been created automatically. Use these to sign in next time:
                    </p>

                    {/* Username row */}
                    <div style={{
                      background:'#fff', borderRadius:10, padding:'11px 14px',
                      marginBottom:8, border:'1px solid #a7f3d0',
                      display:'flex', alignItems:'center', justifyContent:'space-between',
                    }}>
                      <div>
                        <div style={{fontSize:10,fontWeight:700,color:'#6b7280',textTransform:'uppercase',letterSpacing:.5,marginBottom:2}}>
                          Username (Email / Mobile)
                        </div>
                        <div style={{fontSize:14,fontWeight:700,color:'#065f46',fontFamily:'monospace'}}>
                          {form.email || form.mobile || '—'}
                        </div>
                      </div>
                      <Ico name="mail" size={16} color="#059669" />
                    </div>

                    {/* Password row */}
                    <div style={{
                      background:'#fff', borderRadius:10, padding:'11px 14px',
                      border:'1px solid #a7f3d0',
                      display:'flex', alignItems:'center', justifyContent:'space-between',
                    }}>
                      <div>
                        <div style={{fontSize:10,fontWeight:700,color:'#6b7280',textTransform:'uppercase',letterSpacing:.5,marginBottom:2}}>
                          Password
                        </div>
                        <div style={{fontSize:14,fontWeight:700,color:'#065f46',fontFamily:'monospace'}}>
                          {form.mobile || '—'}
                        </div>
                      </div>
                      <Ico name="phone" size={16} color="#059669" />
                    </div>

                    <p style={{fontSize:11,color:'#6b7280',marginTop:10,textAlign:'center'}}>
                      📋 Screenshot this before leaving
                    </p>
                  </div>
                </div>

                {/* Redirect notice */}
                <div style={{
                  padding:'11px 16px', borderRadius:12,
                  background:'var(--brand-light)', border:'1px solid var(--brand-mid)',
                  fontSize:13, color:'var(--brand)', display:'flex', alignItems:'center', gap:8,
                }}>
                  <Ico name="info" size={15} color="var(--brand)" />
                  Redirecting you to your dashboard in a moment…
                </div>
              </div>
            )}
            
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { step } = this.state;
    return (
      <div style={{maxWidth:780,margin:'0 auto'}}>
        <div className="pt-page-header">
          <div>
            <h1 className="pt-page-title">Book Appointment</h1>
            <p className="pt-page-subtitle">Fill in the details to reserve your slot</p>
          </div>
        </div>
        {this.renderStepper()}
        {step===1 && this.renderStep1()}
        {step===2 && this.renderStep3()}
        {step===4 && this.renderStep4()}
      </div>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   MY QR PAGE
═══════════════════════════════════════════════════════════════ */
class MyQRPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointments: [],
      loading:      true,
      error:        null,
      selected:     0,   // index of selected appointment tab
    };
  }

  componentDidMount() { this.fetchAppointments(); }

  async fetchAppointments() {
    this.setState({ loading: true, error: null });
    try {
      // Get PersonID from localStorage
      const raw  = localStorage.getItem('dg_user');
      const user = raw ? JSON.parse(raw) : null;
      const pid  = user?.personId || null;

      // POST with PersonID in body
      const res  = await postRequest(API_ENDPOINTS.MY_APPOINTMENTS, {
        PersonID: pid,   // number or null for guest
      });
      const data = await res.json();

      // Response shape: { status:true, data: [ [...appointments], {metadata} ] }
      // appointments are in data.data[0]
      let rows = [];
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) {
        rows = data.data[0];                          // ✅ real API shape
      } else if (Array.isArray(data.data))            { rows = data.data;   }
      else if (Array.isArray(data))                   { rows = data;        }

      console.log('MyQRPage appointments =', rows);
      this.setState({ appointments: rows, loading: false });
    } catch (err) {
      console.error('MyQRPage fetch error:', err);
      this.setState({ loading: false, error: err.message });
    }
  }

  /* Format ISO date → "02 Apr 2026" */
  fmtDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
  }

  render() {
    const { appointments, loading, error, selected } = this.state;
    const appt = appointments[selected] || null;

    /* Map raw API row → display fields
       Matches the patient payload shape returned from backend */
    // ── Exact API field names from response ─────────────────────
    // PatientFirstName, PatientLastName, DoctorFirstName, DoctorLastName,
    // DepartmentName, Specilization, Appointmentdate, Time,
    // Payment, PaymentStatus, QR_Type, Reason, SelfRelative
    const patientName = appt
      ? `${appt.PatientFirstName || ''} ${appt.PatientLastName || ''}`.trim() || '—'
      : '—';
    const doctorName  = appt
      ? `Dr. ${appt.DoctorFirstName || ''} ${appt.DoctorLastName || ''}`.trim() || '—'
      : '—';
    const dept        = appt?.DepartmentName || '—';
    const spec        = appt?.Specilization  || '';
    const apptDate    = this.fmtDate(appt?.Appointmentdate || appt?.AppointmentDate);
    const apptTime    = appt?.Time           || appt?.AppointmentTime || '—';
    const apptId      = appt?.AppointmentID  || '—';
    const qrType      = appt?.QR_Type        || '—';
    const isPaid      = qrType === 'Official QR' || ['paid','completed'].includes((appt?.PaymentStatus||'').toLowerCase());
    const fees        = appt?.Payment        != null ? `₹${appt.Payment}` : '—';
    const status      = appt?.PaymentStatus  || '—';
    const reason      = appt?.Reason         || '—';
    const relation    = appt?.SelfRelative   || '—';
    const bloodGroup  = appt?.PatientBloodGroup || '—';
    const gender      = appt?.PatientGender     || '—';

    return (
      <div>
        {/* Page header */}
        <div className="pt-page-header">
          <div>
            <h1 className="pt-page-title">My QR Code</h1>
            <p className="pt-page-subtitle">Show this QR at all hospital counters</p>
          </div>
          <button onClick={()=>this.fetchAppointments()}
            style={{border:'1.5px solid var(--border)',background:'transparent',borderRadius:10,padding:'7px 14px',fontSize:12,fontWeight:600,cursor:'pointer',color:'var(--text-2)',fontFamily:'var(--font-body)'}}>
            ↺ Refresh
          </button>
        </div>

        {/* Error banner */}
        {!loading && error && (
          <div className="pt-alert pt-alert-danger" style={{marginBottom:16}}>
            <Ico name="alert" size={14} color="var(--danger)" /> Could not load appointments. {error}
          </div>
        )}

        {/* Loading skeleton — side-by-side */}
        {loading && (
          <div style={{display:'flex',gap:16,alignItems:'flex-start'}}>
            {/* Left skeleton list */}
            <div className="pt-card" style={{width:220,flexShrink:0}}>
              {[1,2,3,4].map(n=>(
                <div key={n} style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',opacity:.45}}>
                  <div style={{height:12,background:'var(--border)',borderRadius:6,marginBottom:5,width:'80%'}} />
                  <div style={{height:10,background:'var(--border)',borderRadius:6,width:'55%'}} />
                </div>
              ))}
            </div>
            {/* Right skeleton QR */}
            <div className="pt-card" style={{flex:1}}>
              <div className="pt-card-body" style={{textAlign:'center',padding:40}}>
                <div style={{width:150,height:150,background:'var(--border)',borderRadius:12,margin:'0 auto 20px',opacity:.4}} />
                <div style={{height:13,background:'var(--border)',borderRadius:6,width:'50%',margin:'0 auto 8px'}} />
                <div style={{height:11,background:'var(--border)',borderRadius:6,width:'70%',margin:'0 auto'}} />
              </div>
            </div>
          </div>
        )}

        {/* No appointments */}
        {!loading && appointments.length === 0 && (
          <div className="pt-card pt-fade-up">
            <div className="pt-card-body" style={{textAlign:'center',padding:48}}>
              <Ico name="qr" size={48} color="var(--border)" />
              <div style={{marginTop:14,fontWeight:700,fontSize:16}}>No Appointments Yet</div>
              <p style={{color:'var(--text-3)',marginTop:6,fontSize:13}}>Book an appointment to get your Smart QR Code.</p>
            </div>
          </div>
        )}

        {/* ── Main layout: vertical list LEFT + QR card RIGHT ── */}
        {!loading && appointments.length > 0 && (
          <div style={{display:'flex',gap:16,alignItems:'flex-start'}}>

            {/* ── LEFT: vertical appointment list ── */}
            <div className="pt-card" style={{width:230,flexShrink:0,overflow:'hidden'}}>
              <div style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:700,color:'var(--text-3)',textTransform:'uppercase',letterSpacing:.5}}>
                Appointments ({appointments.length})
              </div>
              <div style={{maxHeight:520,overflowY:'auto'}}>
                {appointments.map((a, i) => {
                  const d      = this.fmtDate(a.Appointmentdate || a.AppointmentDate);
                  const t      = a.Time || a.AppointmentTime || '';
                  const doc    = `Dr. ${a.DoctorFirstName || ''} ${a.DoctorLastName || ''}`.trim();
                  const isQRPaid   = a.QR_Type === 'Official QR';
                  const isCompleted = (a.PaymentStatus || '').toLowerCase() === 'paid';
                  const isActive = selected === i;
                  return (
                    <button key={i}
                      onClick={() => this.setState({ selected: i })}
                      style={{
                        display:'block', width:'100%', textAlign:'left',
                        padding:'12px 14px',
                        borderBottom:'1px solid var(--border)',
                        background: isActive ? 'var(--brand-light)' : 'transparent',
                        borderLeft: isActive ? '3px solid var(--brand)' : '3px solid transparent',
                        cursor:'pointer', border:'none',
                        borderBottom:'1px solid var(--border)',
                        borderLeft: isActive ? '3px solid var(--brand)' : '3px solid transparent',
                        fontFamily:'var(--font-body)',
                        transition:'background .15s',
                      }}>
                      {/* Date + Time */}
                      <div style={{fontWeight:700,fontSize:13,color:isActive?'var(--brand)':'var(--text-1)',marginBottom:3}}>
                        {t}
                        <span style={{marginLeft:6,fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:20,
                          background: isCompleted?'var(--accent-light)': isQRPaid?'var(--accent-light)':'var(--warn-light)',
                          color:      isCompleted?'#059669': isQRPaid?'#059669':'var(--warn)'}}>
                          {isCompleted ? 'Completed' : isQRPaid ? 'Official' : 'Temp'}
                        </span>
                      </div>
                      <div style={{fontSize:11,color:'var(--text-2)',marginBottom:2}}>{d}</div>
                      <div style={{fontSize:11,color:'var(--text-3)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{doc}</div>
                      <div style={{fontSize:10,color:'var(--text-3)'}}>{a.DepartmentName || ''}</div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* ── RIGHT: QR card ── */}
            <div style={{flex:1,minWidth:0}}>
              <div className="pt-card pt-fade-up">
                <div className="pt-card-body" style={{textAlign:'center'}}>

                  {/* QR visual — use stored QR_IMAGE from API if available, else generate */}
                  {appt?.QR_IMAGE ? (
                    <div style={{textAlign:'center',marginBottom:16}}>
                      <div style={{
                        display:'inline-flex', alignItems:'center', justifyContent:'center',
                        padding:14, borderRadius:16, background:'#fff',
                        boxShadow:'0 4px 20px rgba(0,0,0,.12)',
                        marginBottom:14,
                        border:`2.5px solid ${isPaid?'#a7f3d0':'#fcd9c4'}`,
                      }}>
                        <img src={appt.QR_IMAGE} alt="Appointment QR"
                          style={{width:200,height:200,display:'block'}} />
                      </div>
                      <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,color:isPaid?'var(--accent)':'var(--warn)',marginBottom:10,textTransform:'uppercase'}}>
                        {isPaid ? '✓ Official QR Code' : '⏳ Temporary QR Code'}
                      </div>
                      <div style={{background:isPaid?'var(--accent-light)':'var(--warn-light)',borderRadius:12,padding:'12px 16px',textAlign:'left',fontSize:12,color:'var(--text-2)',lineHeight:2.1}}>
                        <div><strong>Appt ID:</strong> #{apptId}</div>
                        <div><strong>Patient:</strong> {patientName}</div>
                        <div><strong>Doctor:</strong> {doctorName}</div>
                        <div><strong>Date:</strong> {apptDate} · {apptTime}</div>
                      </div>
                      <div style={{marginTop:12,padding:'6px 18px',borderRadius:20,display:'inline-block',background:isPaid?'var(--accent)':'var(--warn)',color:'#fff',fontSize:11,fontWeight:700}}>
                        {isPaid ? 'Payment Confirmed' : 'Pending — Pay at Counter'}
                      </div>
                    </div>
                  ) : (
                    <QRBlock
                      apptId={String(apptId)}
                      patient={patientName}
                      doctor={doctorName}
                      dept={dept}
                      date={apptDate}
                      time={apptTime}
                      gender={gender}
                      blood={bloodGroup}
                      reason={reason}
                      fees={fees}
                      isPaid={isPaid}
                    />
                  )}

                  {/* Info grid */}
                  <div style={{
                    margin:'18px auto 0', textAlign:'left',
                    background:'var(--bg)', borderRadius:12, padding:16,
                    display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px 20px',
                  }}>
                    {[
                      { label:'Patient',        value: patientName              },
                      { label:'Gender / Blood', value: `${gender} · ${bloodGroup}` },
                      { label:'Doctor',         value: doctorName               },
                      { label:'Specialization', value: spec || dept             },
                      { label:'Department',     value: dept                     },
                      { label:'Date',           value: apptDate                 },
                      { label:'Time',           value: apptTime                 },
                      { label:'Fees',           value: fees                     },
                      { label:'Payment',        value: status                   },
                      { label:'QR Type',        value: qrType                   },
                      { label:'For',            value: relation                 },
                      { label:'Reason',         value: reason                   },
                    ].map((row, i) => (
                      <div key={i}>
                        <div style={{fontSize:10,color:'var(--text-3)',fontWeight:600,textTransform:'uppercase',letterSpacing:.4,marginBottom:2}}>
                          {row.label}
                        </div>
                        <div style={{fontSize:13,fontWeight:600,color:'var(--text-1)'}}>{row.value}</div>
                      </div>
                    ))}
                  </div>

                  {/* Action buttons */}
                  <div style={{display:'flex',gap:10,justifyContent:'center',marginTop:18,flexWrap:'wrap'}}>
                    <Btn label="Download" icon="download" variant="primary"  size="sm"
                      onClick={() => {
                        // Download QR image
                        const src = appt?.QR_IMAGE;
                        if (!src) return;
                        const a = document.createElement('a');
                        a.href = src;
                        a.download = `QR-Appt-${apptId}.png`;
                        a.click();
                      }} />
                    <Btn label="Print" icon="printer" variant="secondary" size="sm"
                      onClick={() => {
                        // Open print dialog with QR image
                        const src = appt?.QR_IMAGE;
                        if (!src) return;
                        const win = window.open('', '_blank');
                        win.document.write(`
                          <html><head><title>QR Code - Appt #${apptId}</title>
                          <style>
                            body { font-family: sans-serif; text-align: center; padding: 32px; }
                            img  { width: 220px; height: 220px; display: block; margin: 0 auto 16px; }
                            h2   { margin: 0 0 6px; font-size: 18px; }
                            p    { margin: 4px 0; color: #555; font-size: 13px; }
                          </style></head>
                          <body>
                            <img src="${src}" />
                            <h2>Appointment QR Code</h2>
                            <p><b>Patient:</b> ${patientName}</p>
                            <p><b>Doctor:</b> ${doctorName}</p>
                            <p><b>Date:</b> ${apptDate} · ${apptTime}</p>
                            <p><b>Appt ID:</b> #${apptId}</p>
                            <p><b>Status:</b> ${status}</p>
                            <script>window.onload=()=>{window.print();window.close();}<\/script>
                          </body></html>`);
                        win.document.close();
                      }} />
                    <Btn label="Share" icon="share" variant="secondary" size="sm"
                      onClick={async () => {
                        const src = appt?.QR_IMAGE;
                        const shareUrl = `${window.location.origin}/scan?id=${apptId}`;
                        const text = `DG Doctor Appointment QR\nPatient: ${patientName}\nDoctor: ${doctorName}\nDate: ${apptDate} · ${apptTime}\nAppt ID: #${apptId}\nScan here: ${shareUrl}`;
                        // Try Web Share API (mobile)
                        if (navigator.share && src) {
                          try {
                            // Convert base64 to blob for file share
                            const res   = await fetch(src);
                            const blob  = await res.blob();
                            const file  = new File([blob], `QR-Appt-${apptId}.png`, { type:'image/png' });
                            await navigator.share({ title:'My Appointment QR', text, files:[file] });
                            return;
                          } catch(_) {}
                        }
                        // Fallback: copy scan link to clipboard
                        try {
                          await navigator.clipboard.writeText(shareUrl);
                          alert('Scan link copied to clipboard!\n' + shareUrl);
                        } catch(_) {
                          prompt('Copy this scan link:', shareUrl);
                        }
                      }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   PRESCRIPTION PAGE
═══════════════════════════════════════════════════════════════ */
class PrescriptionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointments: [],   // list from MY_APPOINTMENTS
      selected:     0,    // selected index
      prescription: null, // fetched prescription for selected appt
      apptLoading:  true,
      rxLoading:    false,
      rxFetched:    false, // true after first fetch completes
      apptError:    null,
      rxError:      null,
    };
  }

  componentDidMount() { this.fetchAppointments(); }

  async fetchAppointments() {
    this.setState({ apptLoading: true, apptError: null });
    try {
      const raw  = localStorage.getItem('dg_user');
      const user = raw ? JSON.parse(raw) : null;
      const pid  = user?.personId || null;
      const res  = await postRequest(API_ENDPOINTS.MY_APPOINTMENTS, { PersonID: pid });
      const data = await res.json();
      let rows = [];
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) rows = data.data[0];
      else if (Array.isArray(data.data)) rows = data.data;
      else if (Array.isArray(data))      rows = data;
      this.setState({ appointments: rows, apptLoading: false }, () => {
        if (rows.length > 0) this.fetchPrescription(rows[0], 0);
      });
    } catch (err) {
      this.setState({ apptLoading: false, apptError: err.message });
    }
  }

  async fetchPrescription(appt, idx) {
    const apptId = appt?.AppointmentID || appt?.id;
    if (!apptId) return;
    this.setState({ selected: idx, rxLoading: true, rxError: null, prescription: null });
    try {
      const res  = await postRequest(API_ENDPOINTS.GET_PRESCRIPTION, { AppointmentID: apptId });
      const data = await res.json();
      console.log('Prescription API response:', data);

      // Shape: { status, data: [[{PrescriptionID, Medicines_details, ...}], metadata] }
      let rx = null;
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) {
        rx = data.data[0][0] || null;           // ✅ real shape
      } else if (Array.isArray(data.data))      { rx = data.data[0] || null; }
      else if (data.data && !Array.isArray(data.data)) { rx = data.data; }
      else if (Array.isArray(data))             { rx = data[0] || null; }

      this.setState({ prescription: rx, rxLoading: false, rxFetched: true });
    } catch (err) {
      this.setState({ rxLoading: false, rxError: err.message, rxFetched: true });
    }
  }

  fmtDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
  }

  render() {
    const { appointments, selected, prescription, apptLoading, rxLoading, rxError, rxFetched } = this.state;
    const appt = appointments[selected] || null;

    // Map appt fields
    const doctorName  = appt ? `Dr. ${appt.DoctorFirstName||''} ${appt.DoctorLastName||''}`.trim() : '—';
    const doctorInitials = appt ? `${(appt.DoctorFirstName||'')[0]||''}${(appt.DoctorLastName||'')[0]||''}`.toUpperCase() : '—';
    const dept        = appt?.DepartmentName || '—';
    const apptDate    = this.fmtDate(appt?.Appointmentdate || appt?.AppointmentDate);
    const apptId      = appt?.AppointmentID || '—';
    const status      = appt?.PaymentStatus || '—';
    const isPaid      = status.toLowerCase() === 'paid';

    // Prescription fields — plain text from API
    // API field: Medicines_details (from response preview)
    const medicines = prescription?.Medicines_details || prescription?.Medicines || prescription?.medicines || '';
    const labTests  = prescription?.LabTests_details  || prescription?.LabTests  || prescription?.labTests  || prescription?.tests || '';

    return (
      <div>
        {/* Page header */}
        <div className="pt-page-header">
          <div>
            <h1 className="pt-page-title">My Prescription</h1>
            <p className="pt-page-subtitle">Click an appointment to view its prescription</p>
          </div>
          <button onClick={() => this.fetchAppointments()}
            style={{border:'1.5px solid var(--border)',background:'transparent',borderRadius:10,padding:'7px 14px',fontSize:12,fontWeight:600,cursor:'pointer',color:'var(--text-2)',fontFamily:'var(--font-body)'}}>
            ↺ Refresh
          </button>
        </div>

        {/* Loading appts skeleton */}
        {apptLoading && (
          <div style={{display:'flex',gap:16,alignItems:'flex-start'}}>
            <div className="pt-card" style={{width:230,flexShrink:0}}>
              {[1,2,3].map(n=>(
                <div key={n} style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',opacity:.45}}>
                  <div style={{height:12,background:'var(--border)',borderRadius:6,marginBottom:5,width:'80%'}} />
                  <div style={{height:10,background:'var(--border)',borderRadius:6,width:'55%'}} />
                </div>
              ))}
            </div>
            <div className="pt-card" style={{flex:1,padding:32,opacity:.4,textAlign:'center'}}>
              <Ico name="pill" size={36} color="var(--border)" />
            </div>
          </div>
        )}

        {/* No appointments */}
        {!apptLoading && appointments.length === 0 && (
          <div className="pt-card">
            <div className="pt-card-body" style={{textAlign:'center',padding:48}}>
              <Ico name="pill" size={48} color="var(--border)" />
              <div style={{marginTop:14,fontWeight:700,fontSize:16}}>No Appointments Yet</div>
              <p style={{color:'var(--text-3)',marginTop:6,fontSize:13}}>Book an appointment to get a prescription.</p>
            </div>
          </div>
        )}

        {/* Main layout — list LEFT + prescription RIGHT */}
        {!apptLoading && appointments.length > 0 && (
          <div style={{display:'flex',gap:16,alignItems:'flex-start'}}>

            {/* ── LEFT: appointment list ── */}
            <div className="pt-card" style={{width:230,flexShrink:0,overflow:'hidden'}}>
              <div style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:700,color:'var(--text-3)',textTransform:'uppercase',letterSpacing:.5}}>
                Appointments ({appointments.length})
              </div>
              <div style={{maxHeight:560,overflowY:'auto'}}>
                {appointments.map((a, i) => {
                  const d   = this.fmtDate(a.Appointmentdate || a.AppointmentDate);
                  const t   = a.Time || a.AppointmentTime || '';
                  const doc = `Dr. ${a.DoctorFirstName||''} ${a.DoctorLastName||''}`.trim();
                  const isActive = selected === i;
                  const isOfficial  = a.QR_Type === 'Official QR';
                  const isCompleted = (a.PaymentStatus || '').toLowerCase() === 'paid';
                  return (
                    <button key={i}
                      onClick={() => this.fetchPrescription(a, i)}
                      style={{
                        display:'block',width:'100%',textAlign:'left',
                        padding:'12px 14px',
                        background: isActive ? 'var(--brand-light)' : 'transparent',
                        borderLeft: isActive ? '3px solid var(--brand)' : '3px solid transparent',
                        borderBottom:'1px solid var(--border)',
                        border:'none', borderBottom:'1px solid var(--border)',
                        borderLeft: isActive ? '3px solid var(--brand)' : '3px solid transparent',
                        cursor:'pointer',fontFamily:'var(--font-body)',transition:'background .15s',
                      }}>
                      <div style={{fontWeight:700,fontSize:13,color:isActive?'var(--brand)':'var(--text-1)',marginBottom:3}}>
                        {t}
                        <span style={{marginLeft:6,fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:20,
                          background:isCompleted?'var(--accent-light)':isOfficial?'var(--accent-light)':'var(--warn-light)',
                          color:isCompleted?'#059669':isOfficial?'#059669':'var(--warn)'}}>
                          {isCompleted?'Completed':isOfficial?'Official':'Temp'}
                        </span>
                      </div>
                      <div style={{fontSize:11,color:'var(--text-2)',marginBottom:2}}>{d}</div>
                      <div style={{fontSize:11,color:'var(--text-3)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{doc}</div>
                      <div style={{fontSize:10,color:'var(--text-3)'}}>{a.DepartmentName||''}</div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* ── RIGHT: prescription detail ── */}
            <div style={{flex:1,minWidth:0}}>

              {/* Doctor info card */}
              {appt && (
                <div className="pt-card pt-fade-up" style={{marginBottom:14}}>
                  <div className="pt-card-body">
                    <div style={{display:'flex',alignItems:'center',gap:14}}>
                      <div className="pt-doctor-avatar" style={{width:48,height:48,borderRadius:12,fontSize:15,flexShrink:0}}>
                        {doctorInitials}
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:700,fontSize:15}}>{doctorName}</div>
                        <div style={{fontSize:12,color:'var(--text-3)'}}>
                          {dept} · Appt #{apptId} · {apptDate}
                        </div>
                      </div>
                      <Badge label={status} bg={isPaid?'var(--accent-light)':'var(--warn-light)'} color={isPaid?'#059669':'var(--warn)'} />
                    </div>
                  </div>
                </div>
              )}

              {/* Rx loading */}
              {rxLoading && (
                <div className="pt-card">
                  <div className="pt-card-body" style={{textAlign:'center',padding:40,color:'var(--text-3)'}}>
                    <Ico name="pill" size={28} color="var(--border)" />
                    <p style={{marginTop:10,fontSize:13}}>Loading prescription…</p>
                  </div>
                </div>
              )}

              {/* Rx error */}
              {rxError && !rxLoading && (
                <div className="pt-card">
                  <div className="pt-card-body" style={{textAlign:'center',padding:40,color:'var(--text-3)'}}>
                    <Ico name="alert" size={28} color="var(--warn)" />
                    <p style={{marginTop:10,fontSize:13}}>Could not load prescription.</p>
                  </div>
                </div>
              )}



              {/* ── No prescription ── */}
              {!rxLoading && rxFetched && !rxError && !medicines && !labTests && (
                <div className="pt-card pt-fade-up">
                  <div className="pt-card-body" style={{textAlign:'center',padding:'36px 20px'}}>
                    <Ico name="pill" size={36} color="var(--border)" />
                    <div style={{marginTop:12,fontWeight:700,fontSize:15,color:'var(--text-2)'}}>No Record Found</div>
                    <p style={{color:'var(--text-3)',marginTop:6,fontSize:13}}>No prescription has been written for this appointment yet.</p>
                  </div>
                </div>
              )}

              {/* ── Medicines card ── */}
              {!rxLoading && medicines && (() => {
                // Parse plain text lines → individual medicine cards
                // Lines look like: "1. Paracetamol 500mg – Twice daily – After food – 5 days"
                const lines = medicines
                  .split(/\\n|\n/).map(l => l.replace(/^[0-9]+[.)]\s*/, '').trim()).filter(Boolean)
                  .map(l => l.replace(/^[0-9]+[.)]\s*/, '').trim())
                  .filter(Boolean);

                return (
                  <div className="pt-card pt-fade-up" style={{marginBottom:14}}>
                    <div className="pt-card-header">
                      <div>
                        <div className="pt-card-title">💊 Prescribed Medicines</div>
                        <div className="pt-card-subtitle">{lines.length} medicine{lines.length !== 1 ? 's' : ''}</div>
                      </div>
                    </div>
                    <div className="pt-card-body" style={{paddingTop:8}}>
                      {lines.map((line, i) => {
                        // Split on – or - or · to get parts: name, freq, instr, duration
                        const parts = line.split(/\s*[–—·-]\s*/).map(p => p.trim()).filter(Boolean);
                        const name  = parts[0] || line;
                        const rest  = parts.slice(1);
                        return (
                          <div key={i} className="pt-rx-card">
                            <div className="pt-rx-icon-wrap">
                              <Ico name="pill" size={19} color="var(--warn)" />
                            </div>
                            <div style={{flex:1}}>
                              <div style={{fontWeight:700,fontSize:14}}>{name}</div>
                              {rest.length > 0 && (
                                <div style={{fontSize:12,color:'var(--text-3)',marginTop:3}}>
                                  {rest.join(' · ')}
                                </div>
                              )}
                            </div>
                            <Badge label="Active" bg="var(--accent-light)" color="#059669" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })()}

              {/* ── Lab Tests card ── */}
              {!rxLoading && labTests && (() => {
                const lines = labTests
                  .split('\n')
                  .map(l => l.replace(/^[0-9]+[.)]\s*/, '').trim())
                  .filter(Boolean);

                return (
                  <div className="pt-card pt-fade-up-1">
                    <div className="pt-card-header">
                      <div>
                        <div className="pt-card-title">🔬 Lab Test Orders</div>
                        <div className="pt-card-subtitle">{lines.length} test{lines.length !== 1 ? 's' : ''}</div>
                      </div>
                    </div>
                    <div className="pt-card-body" style={{paddingTop:8}}>
                      {lines.map((line, i) => {
                        const parts = line.split(/\s*[–—·-]\s*/).map(p => p.trim()).filter(Boolean);
                        const name  = parts[0] || line;
                        const rest  = parts.slice(1);
                        return (
                          <div key={i} className="pt-rx-card">
                            <div className="pt-rx-icon-wrap" style={{background:'var(--purple-light,#F0EDFE)'}}>
                              <Ico name="flask" size={19} color="var(--purple,#7B5CF6)" />
                            </div>
                            <div style={{flex:1}}>
                              <div style={{fontWeight:700,fontSize:14}}>{name}</div>
                              {rest.length > 0 && (
                                <div style={{fontSize:12,color:'var(--text-3)',marginTop:3}}>
                                  {rest.join(' · ')}
                                </div>
                              )}
                            </div>
                            <Badge label="Ordered" bg="var(--brand-light)" color="var(--brand)" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   LAB RESULTS PAGE
═══════════════════════════════════════════════════════════════ */
class LabResultsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointments: [],
      selected:     0,
      labData:      null,
      labText:      '',
      apptLoading:  true,
      labLoading:   false,
      labFetched:   false,
      labReports:   [],
      apptError:    null,
      labError:     null,
    };
  }

  componentDidMount() { this.fetchAppointments(); }

  async fetchAppointments() {
    this.setState({ apptLoading: true, apptError: null });
    try {
      const raw  = localStorage.getItem('dg_user');
      const user = raw ? JSON.parse(raw) : null;
      const pid  = user?.personId || null;
      const res  = await postRequest(API_ENDPOINTS.MY_APPOINTMENTS, { PersonID: pid });
      const data = await res.json();
      let rows = [];
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) rows = data.data[0];
      else if (Array.isArray(data.data)) rows = data.data;
      else if (Array.isArray(data))      rows = data;
      this.setState({ appointments: rows, apptLoading: false }, () => {
        if (rows.length > 0) this.fetchLabResults(rows[0], 0);
      });
    } catch (err) {
      this.setState({ apptLoading: false, apptError: err.message });
    }
  }

  async fetchLabResults(appt, idx) {
    const apptId = appt?.AppointmentID || appt?.id;
    if (!apptId) return;
    this.setState({ selected: idx, labLoading: true, labError: null, labData: null, labText: '', labFetched: false });
    try {
      const res  = await postRequest(API_ENDPOINTS.GET_LAB_RESULTS, { AppointmentID: apptId });
      const data = await res.json();
      console.log('Lab results response:', data);
      // Handle same SP double-array shape
      let rx = null;
      if (data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) {
        rx = data.data[0][0] || null;
      } else if (Array.isArray(data.data)) { rx = data.data[0] || null; }
      else if (data.data && !Array.isArray(data.data)) { rx = data.data; }
      else if (Array.isArray(data))        { rx = data[0] || null; }

      // Extract lab text — adjust field name once you see actual response
      const labText = rx?.Lab_test_details || rx?.LabTests_details || rx?.LabTests || rx?.labTests || rx?.tests || '';

      // Extract labReport array for file paths
      let labReports = [];
      if (Array.isArray(data.labReport?.[0]))  labReports = data.labReport[0];
      else if (Array.isArray(data.labReport))  labReports = data.labReport;

      this.setState({ labData: rx, labText, labReports, labLoading: false, labFetched: true });
    } catch (err) {
      this.setState({ labLoading: false, labError: err.message, labFetched: true });
    }
  }

  fmtDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
  }

  render() {
    const { appointments, selected, labText, labReports, apptLoading, labLoading, labError, labFetched } = this.state;
    const appt = appointments[selected] || null;

    const doctorName     = appt ? `Dr. ${appt.DoctorFirstName||''} ${appt.DoctorLastName||''}`.trim() : '—';
    const doctorInitials = appt ? `${(appt.DoctorFirstName||'')[0]||''}${(appt.DoctorLastName||'')[0]||''}`.toUpperCase() : '—';
    const dept           = appt?.DepartmentName || '—';
    const apptDate       = this.fmtDate(appt?.Appointmentdate || appt?.AppointmentDate);
    const apptId         = appt?.AppointmentID || '—';
    const status         = appt?.PaymentStatus || '—';
    const isPaid         = status.toLowerCase() === 'paid';

    // Parse lab text into lines
    const labLines = labText
      ? labText.split(/\\n|\n/).map(l => l.replace(/^[0-9]+[.)]\s*/, '').trim()).filter(Boolean)
      : [];

    return (
      <div>
        {/* Page header */}
        <div className="pt-page-header">
          <div>
            <h1 className="pt-page-title">Lab Results</h1>
            <p className="pt-page-subtitle">Click an appointment to view its lab tests</p>
          </div>
          <button onClick={() => this.fetchAppointments()}
            style={{border:'1.5px solid var(--border)',background:'transparent',borderRadius:10,padding:'7px 14px',fontSize:12,fontWeight:600,cursor:'pointer',color:'var(--text-2)',fontFamily:'var(--font-body)'}}>
            ↺ Refresh
          </button>
        </div>

        {/* Loading skeleton */}
        {apptLoading && (
          <div style={{display:'flex',gap:16,alignItems:'flex-start'}}>
            <div className="pt-card" style={{width:230,flexShrink:0}}>
              {[1,2,3].map(n=>(
                <div key={n} style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',opacity:.45}}>
                  <div style={{height:12,background:'var(--border)',borderRadius:6,marginBottom:5,width:'80%'}} />
                  <div style={{height:10,background:'var(--border)',borderRadius:6,width:'55%'}} />
                </div>
              ))}
            </div>
            <div className="pt-card" style={{flex:1,padding:32,opacity:.4,textAlign:'center'}}>
              <Ico name="flask" size={36} color="var(--border)" />
            </div>
          </div>
        )}

        {/* No appointments */}
        {!apptLoading && appointments.length === 0 && (
          <div className="pt-card">
            <div className="pt-card-body" style={{textAlign:'center',padding:48}}>
              <Ico name="flask" size={48} color="var(--border)" />
              <div style={{marginTop:14,fontWeight:700,fontSize:16}}>No Appointments Yet</div>
              <p style={{color:'var(--text-3)',marginTop:6,fontSize:13}}>Book an appointment to get lab tests.</p>
            </div>
          </div>
        )}

        {/* Main layout */}
        {!apptLoading && appointments.length > 0 && (
          <div style={{display:'flex',gap:16,alignItems:'flex-start'}}>

            {/* LEFT: appointment list */}
            <div className="pt-card" style={{width:230,flexShrink:0,overflow:'hidden'}}>
              <div style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:700,color:'var(--text-3)',textTransform:'uppercase',letterSpacing:.5}}>
                Appointments ({appointments.length})
              </div>
              <div style={{maxHeight:560,overflowY:'auto'}}>
                {appointments.map((a, i) => {
                  const d = this.fmtDate(a.Appointmentdate || a.AppointmentDate);
                  const t = a.Time || a.AppointmentTime || '';
                  const doc = `Dr. ${a.DoctorFirstName||''} ${a.DoctorLastName||''}`.trim();
                  const isActive   = selected === i;
                  const isOfficial  = a.QR_Type === 'Official QR';
                  const isCompleted = (a.PaymentStatus || '').toLowerCase() === 'paid';
                  return (
                    <button key={i}
                      onClick={() => this.fetchLabResults(a, i)}
                      style={{
                        display:'block',width:'100%',textAlign:'left',
                        padding:'12px 14px',
                        background: isActive ? 'var(--brand-light)' : 'transparent',
                        borderLeft: isActive ? '3px solid var(--brand)' : '3px solid transparent',
                        border:'none', borderBottom:'1px solid var(--border)',
                        borderLeft: isActive ? '3px solid var(--brand)' : '3px solid transparent',
                        cursor:'pointer', fontFamily:'var(--font-body)', transition:'background .15s',
                      }}>
                      <div style={{fontWeight:700,fontSize:13,color:isActive?'var(--brand)':'var(--text-1)',marginBottom:3}}>
                        {t}
                        <span style={{marginLeft:6,fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:20,
                          background:isCompleted?'var(--accent-light)':isOfficial?'var(--accent-light)':'var(--warn-light)',
                          color:isCompleted?'#059669':isOfficial?'#059669':'var(--warn)'}}>
                          {isCompleted?'Completed':isOfficial?'Official':'Temp'}
                        </span>
                      </div>
                      <div style={{fontSize:11,color:'var(--text-2)',marginBottom:2}}>{d}</div>
                      <div style={{fontSize:11,color:'var(--text-3)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{doc}</div>
                      <div style={{fontSize:10,color:'var(--text-3)'}}>{a.DepartmentName||''}</div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* RIGHT: lab results */}
            <div style={{flex:1,minWidth:0}}>

              {/* Doctor info card */}
              {appt && (
                <div className="pt-card pt-fade-up" style={{marginBottom:14}}>
                  <div className="pt-card-body">
                    <div style={{display:'flex',alignItems:'center',gap:14}}>
                      <div className="pt-doctor-avatar" style={{width:48,height:48,borderRadius:12,fontSize:15,flexShrink:0}}>
                        {doctorInitials}
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:700,fontSize:15}}>{doctorName}</div>
                        <div style={{fontSize:12,color:'var(--text-3)'}}>{dept} · Appt #{apptId} · {apptDate}</div>
                      </div>
                      <Badge label={status} bg={isPaid?'var(--accent-light)':'var(--warn-light)'} color={isPaid?'#059669':'var(--warn)'} />
                    </div>
                  </div>
                </div>
              )}

              {/* Loading */}
              {labLoading && (
                <div className="pt-card">
                  <div className="pt-card-body" style={{textAlign:'center',padding:40,color:'var(--text-3)'}}>
                    <Ico name="flask" size={28} color="var(--border)" />
                    <p style={{marginTop:10,fontSize:13}}>Loading lab results…</p>
                  </div>
                </div>
              )}

              {/* Error */}
              {labError && !labLoading && (
                <div className="pt-card">
                  <div className="pt-card-body" style={{textAlign:'center',padding:40}}>
                    <Ico name="alert" size={28} color="var(--warn)" />
                    <p style={{marginTop:10,fontSize:13,color:'var(--text-3)'}}>Could not load lab results.</p>
                  </div>
                </div>
              )}

              {/* No record */}
              {!labLoading && labFetched && !labError && labLines.length === 0 && (
                <div className="pt-card pt-fade-up">
                  <div className="pt-card-body" style={{textAlign:'center',padding:'36px 20px'}}>
                    <Ico name="flask" size={36} color="var(--border)" />
                    <div style={{marginTop:12,fontWeight:700,fontSize:15,color:'var(--text-2)'}}>No Record Found</div>
                    <p style={{color:'var(--text-3)',marginTop:6,fontSize:13}}>No lab tests have been ordered for this appointment yet.</p>
                  </div>
                </div>
              )}

              {/* Lab test cards */}
              {!labLoading && labLines.length > 0 && (
                <div className="pt-card pt-fade-up">
                  <div className="pt-card-header">
                    <div>
                      <div className="pt-card-title">🔬 Lab Test Orders</div>
                      <div className="pt-card-subtitle">{labLines.length} test{labLines.length !== 1 ? 's' : ''}</div>
                    </div>
                  </div>
                  <div className="pt-card-body" style={{paddingTop:8}}>
                    {labLines.map((line, i) => {
                      const parts  = line.split(/\s*[–—·-]\s*/).map(p => p.trim()).filter(Boolean);
                      const name   = parts[0] || line;
                      const rest   = parts.slice(1);
                      const report = labReports[i] || labReports.find(r =>
                        (r.LabTestName||'').toLowerCase().includes(name.toLowerCase().split(' ')[0])
                      );
                      const hasFile = report?.Path && report.Path !== null && report.Path !== '';
                      const openFile = () => {
                        const cleanPath = report.Path.replace(/\\/g,'/').replace(/^\.\.\//, '');
                        const host = window.location.hostname;
                        window.open(`https://${host}/backend/${cleanPath}`, '_blank');
                      };
                      return (
                        <div key={i} className="pt-rx-card">
                          <div className="pt-rx-icon-wrap" style={{background:'#F0EDFE'}}>
                            <Ico name="flask" size={19} color="var(--purple)" />
                          </div>
                          <div style={{flex:1}}>
                            <div style={{fontWeight:700,fontSize:14}}>{name}</div>
                            {rest.length > 0 && (
                              <div style={{fontSize:12,color:'var(--text-3)',marginTop:3}}>{rest.join(' · ')}</div>
                            )}
                            {report?.Report_Status && (
                              <div style={{fontSize:11,color:'var(--text-3)',marginTop:2,textTransform:'capitalize'}}>
                                Status: <strong style={{color:report.Report_Status.toLowerCase()==='completed'?'#059669':'var(--text-3)'}}>{report.Report_Status}</strong>
                              </div>
                            )}
                          </div>
                          {hasFile ? (
                            <button onClick={openFile}
                              style={{padding:'5px 12px',borderRadius:20,border:'1.5px solid var(--purple,#7B5CF6)',background:'#F0EDFE',color:'var(--purple,#7B5CF6)',fontSize:11,fontWeight:700,cursor:'pointer',fontFamily:'var(--font-body)',whiteSpace:'nowrap'}}>
                              📄 View File
                            </button>
                          ) : (
                            <Badge label="Ordered" bg="var(--brand-light)" color="var(--brand)" />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   BOTTOM NAV (mobile)
═══════════════════════════════════════════════════════════════ */
class BottomNav extends Component {
  render() {
    const { activePage, onNav } = this.props;
    const ITEMS = [
      {id:'book',         label:'Book',  icon:'calendar'},
      {id:'my-qr',        label:'QR',    icon:'qr'      },
      {id:'prescription', label:'Rx',    icon:'pill'    },
      {id:'lab-results',  label:'Lab',   icon:'flask'   },
    ];
    return (
      <nav className="pt-bottom-nav">
        {ITEMS.map(item => (
          <button key={item.id}
            className={`pt-bottom-nav-btn${activePage===item.id?' active':''}`}
            onClick={()=>onNav(item.id)}>
            <Ico name={item.icon} size={20} color={activePage===item.id?'var(--brand)':'var(--text-3)'} />
            {item.label}
          </button>
        ))}
      </nav>
    );
  }
}

/* ═══════════════════════════════════════════════════════════════
   PATIENT DASHBOARD ROOT
═══════════════════════════════════════════════════════════════ */
const PAGE_META = {
  'book':         {title:'Book Appointment',  subtitle:'Online booking wizard'         },
  'my-qr':        {title:'My QR Code',        subtitle:'Your Smart QR'                 },
  'prescription': {title:'Prescription',       subtitle:'Medicines prescribed by doctor'},
  'lab-results':  {title:'Lab Results',        subtitle:'Your test reports'             },
};

export class PatientDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { activePage:'book', sidebarOpen:false };
  }
  setPage(page)    { this.setState({ activePage:page, sidebarOpen:false }); }
  toggleSidebar()  { this.setState(s => ({ sidebarOpen:!s.sidebarOpen })); }

  renderPage() {
    const { onLogin } = this.props;
    switch (this.state.activePage) {
      case 'book':         return <BookAppointment onLogin={onLogin} />;
      case 'my-qr':        return <MyQRPage />;
      case 'prescription': return <PrescriptionPage />;
      case 'lab-results':  return <LabResultsPage />;
      default:             return <BookAppointment onLogin={onLogin} />;
    }
  }

  render() {
    const { activePage, sidebarOpen } = this.state;
    const meta = PAGE_META[activePage] || PAGE_META['book'];
    return (
      <div className="pt-shell">
        <Sidebar activePage={activePage} onNav={p=>this.setPage(p)}
          isOpen={sidebarOpen} onClose={()=>this.setState({sidebarOpen:false})}
          onLogout={this.props.onLogout} />
        <div className="pt-main">
          <Header title={meta.title} subtitle={meta.subtitle} onMenuClick={()=>this.toggleSidebar()} />
          <main className="pt-content">{this.renderPage()}</main>
        </div>
        <BottomNav activePage={activePage} onNav={p=>this.setPage(p)} />
      </div>
    );
  }
}

export default PatientDashboard;